module.exports = __webpack_public_path__ + "img/icon_system_dictionary_create.791626b2.svg";